import { makeAutoObservable } from "mobx";
import { IPartType, ISimpleResponce } from "@drone-parts.garphild.pro/interfaces";
import { notification } from "antd";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { IPartTypeDto } from "@drone-parts.garphild.pro/interfaces";

class PartTypesStorage {
  partTypes: IPartType[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  get mainPartTypeNames() {
    const mainPartTypes = new Set();
    for (const pt of this.partTypes) {
      const mainKey = pt.key?.split(':')?.[0];
      if (mainKey) {
        mainPartTypes.add(mainKey);
      }
    }
    return Array.from(mainPartTypes);
  }

  get partTypesFull() {
    return this.partTypes.map((partType) => {
      return partType.subcategories?.map((subCategory) => ({
        ...subCategory,
        imageUrl: subCategory.imageUrl || partType.imageUrl || 'https://via.placeholder.com/150',
      })) || [];
    }).flat();
  }

  loadPartTypes = async () => {
    try {
      const data = await RestApiQuery.get<ISimpleResponce<IPartType[]>>(ApiEndpoints.SprPartTypes)
      if (!data) {
        throw new Error("Failed to load part types");
      }
      this.partTypes = [...data.data];
    } catch (error) {
      notification.error({ message: "Failed to load part types" });
    }
  }

  addPartType = async (param: Partial<IPartTypeDto>) => {
    try {
      const partType = await RestApiQuery.post<Partial<IPartTypeDto>, ISimpleResponce<IPartType>>(`/api/spr/part-types`, param)
      if (!partType) {
        throw new Error("Failed to create part type");
      }

      this.partTypes = [...this.partTypes, partType.data];
      return partType.data;
    } catch (error) {
      notification.error({ message: "Failed to create part type" });
    }
  }
}

const partTypesStorage = new PartTypesStorage();

export default partTypesStorage;
